<template>
  <div class="my-samples">
    <h2 v-if="!user_id">My Samples:</h2>
    <h2 v-if="user_id && user">Samples for {{ user.name }} ({{ user.email }}):</h2>
    <div v-if="$auth.check('admin')">
      <router-link :to="`/sample/edit/${user_id}`">
        <button class="red-button">Add New Sample</button>
      </router-link>
      <br/><br/>
    </div>
    <TableComponent :data="samples"
                    sort-by="sample_date"
                    sort-order="desc"
                    :show-filter="false"
                    :show-caption="false">
      <TableColumn v-if="$auth.check('admin')" show="edit_link" label="Edit"></TableColumn>
      <TableColumn show="link" label="View"></TableColumn>
      <TableColumn show="loc_id" :formatter="getLocName" label="Site"></TableColumn>
      <TableColumn show="var_id" :formatter="getVarName" label="Variety"></TableColumn>
      <TableColumn show="sample_date_linked" label="Sample Date"></TableColumn>
      <TableColumn show="skin_tannin_coloured" label="Skin Tannin">
        <template scope="row">
          <Popper trigger="hover" :options="{placement: 'top'}">
            <RangePopup
                        :range="levels[row.var_id].skin"
                        title="Skin Tannin"
                        :val="row.skin_tannin"></RangePopup>
            <span slot="reference">
              <span :class="row.skin_colour_class">{{row.skin_tannin}}</span>
            </span>
          </Popper>
        </template>
      </TableColumn>
      <TableColumn show="seed_tannin_coloured" label="Seed Tannin">
        <template scope="row">
          <Popper trigger="hover" :options="{placement: 'top'}">
            <RangePopup
                        :range="levels[row.var_id].seed"
                        title="Seed Tannin"
                        :val="row.seed_tannin"></RangePopup>
            <span slot="reference">
              <span :class="row.seed_colour_class">{{row.seed_tannin}}</span>
            </span>
          </Popper>
        </template>
      </TableColumn>
      <TableColumn show="seeds_per_berry" label="Seeds/Berry"></TableColumn>
      <TableColumn show="berry_weight" label="Fresh Berry Weight (g)"></TableColumn>
    </TableComponent>
  </div>
</template>

<script>
import Popper from 'vue-popperjs';
import axios from 'axios';
import { TableComponent, TableColumn } from 'vue-table-component';
import RangePopup from '../components/RangePopup';

export default {
  name: 'UserSamplesListing',
  components: {
    TableComponent,
    TableColumn,
    RangePopup,
    Popper,
  },
  props: ['user_id'],
  watch: {
    user_id: function (newVal, oldVal) {
      this.$store.dispatch('getSamplesByUser', {
        user_id: (this.user_id) ? this.user_id : this.$auth.user().id,
      });
    },
  },
  created() {
    if (this.user_id) {
      axios.get(`users/${this.user_id}`)
        .then((res) => {
          // console.log(response);
          this.user = res.data;
        }).catch((err) => {
          console.log(err);
        });
    }
    this.$store.dispatch('getLevels');
    this.$store.dispatch('getYears');
    this.$store.dispatch('getVarieties');
    this.$store.dispatch('getLocationsAll');
    this.$store.dispatch('getSamplesByUser', {
      user_id: (this.user_id) ? this.user_id : this.$auth.user().id,
    });
  },
  data() {
    return {
      user: null,
    };
  },
  computed: {
    levels() {
      return this.$store.state.levels;
    },
    samples() {
      if (this.levels.length <= 0) {
        return [];
      }
      const tempSamples = this.$store.state.samplesByUser;
      tempSamples.forEach((sample, index) => {
        tempSamples[index].link = `<a href="#/samples/${sample.id}">View</a>`;
        tempSamples[index].edit_link = `<a href="#/sample/edit/${sample.sample_date}/${sample.loc_id}/${sample.var_id}">Edit</a>`;
        tempSamples[index].sample_date_linked =
          `<a href="#/samples/${sample.id}">${sample.sample_date}</a>`;
        tempSamples[index].skin_colour_class =
          this.getClass(
            tempSamples[index].skin_tannin,
            this.levels[sample.var_id].skin);
        tempSamples[index].seed_colour_class =
          this.getClass(
            tempSamples[index].seed_tannin,
            this.levels[sample.var_id].seed);
      });
      return tempSamples;
    },
  },
  methods: {
    getLocName(locId) {
      let ret = 'Unknown Site';
      this.$store.state.locationsAll.forEach((location) => {
        if (location.id === locId) {
          ret = location.name;
        }
      });
      return ret;
    },
    getVarName(varId) {
      let ret = 'Unknown Variety';
      this.$store.state.varieties.forEach((variety) => {
        if (variety.id === varId) {
          ret = variety.name;
        }
      });
      return ret;
    },
    getClass(val, ranges) {
      let finalLevel = 0;
      // console.log(val);
      // console.log(ranges);
      for (let i = 0; i < ranges.length; i += 1) {
        if (val >= ranges[i]) {
          finalLevel += 1;
        } else {
          break;
        }
      }
      return this.indexToLevelClass(finalLevel - 1);
    },
    indexToLevelClass(index) {
      switch (index) {
        case 0:
          return 'tannin-cell low';
        case 1:
          return 'tannin-cell med';
        case 2:
          return 'tannin-cell high';
        default:
          return '';
      }
    },
  },
};
</script>

<style lang="scss">
@import '../assets/_colors.scss';
@import '../assets/_globals.scss';
@import '../assets/_common.scss';

.chart{
  height: 400px;
  position: relative;
}
.my-samples{
  position: relative;
}

.table-component {
  display: flex;
  flex-direction: column;
}

.table-component > *,
.table-component > *:after,
.table-component > *:before {
  position: relative;
}

.table-component__filter {
  align-self: flex-end;
}

.table-component__filter__field {
  padding: 0 1.25em 0 .75em;
  height: 2.5em;
  border: solid 2px #e0e0e0;
  border-radius: 2em;
  font-size: inherit;
}

.table-component__filter__clear {
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 2em;
  color: #007593;
  font-weight: bold;
  cursor: pointer;
}

.table-component__filter__field:focus {
  outline: 0;
  border-color: #007593;
}

.table-component__table-wrapper {
  overflow-x: auto;
  margin: 0.5rem 0 1rem 0;
  width: 100%;
  border: solid 1px #ddd;
  border-bottom: none;
}

.table-component__table {
  min-width: 100%;
  border-collapse: collapse;
  border-bottom: solid 1px #ddd;
  table-layout: fixed;
}

.table-component__table__caption {
  position: absolute;
  top: auto;
  left: -10000px;
  overflow: hidden;
  width: 1px;
  height: 1px;
}

.table-component__table th,
.table-component__table td {
  padding: .75em 1.25em;
  vertical-align: center;
  text-align: left;
}

.table-component__table th {
  background-color: #e0e0e0;
  color: #555;
  /*text-transform: uppercase;*/
  white-space: nowrap;
  font-size: .85em;
}

.table-component__table tbody tr:nth-child(even) {
  background-color: #f0f0f0;
}

.table-component__table a {
  color: #007593;
}

.table-component__message {
  color: #999;
  font-style: italic;
}

.table-component__th--sort,
.table-component__th--sort-asc,
.table-component__th--sort-desc {
  text-decoration: underline;
  cursor: pointer;
  -webkit-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;
}

.table-component__th--sort-asc:after,
.table-component__th--sort-desc:after {
  position: absolute;
  left: .25em;
  display: inline-block;
  color: #bbb;
}

.table-component__th--sort-asc:after {
  content: '↑';
}

.table-component__th--sort-desc:after {
  content: '↓';
}
</style>



// WEBPACK FOOTER //
// src/pages/UserSamplesListing.vue